import { round } from 'lodash-es'
import { NameType, Payload, ValueType } from 'recharts/types/component/DefaultTooltipContent'

import { getValueInThousands } from 'lib/usage/getTotalUsage'

export const TOOLTIP_TEST_ID = 'tooltip-content'

interface TooltipContentProps {
  payload: Array<Payload<ValueType, NameType>>
}

export const TooltipContent = ({ payload }: TooltipContentProps) => {
  const total = payload[0].payload['total']

  const detailedPayload = payload.reduce(
    (acc, { color, payload: nestedPayload, value }, index) => {
      if (index === 0) {
        acc.push({ dataKey: '200', payload: { fill: color as string }, value: value as number })
        return acc
      }
      acc.push({ dataKey: '400', payload: { fill: color as string }, value: nestedPayload['400'] })
      acc.push({ dataKey: '500', payload: { fill: color as string }, value: nestedPayload['500'] })
      return acc
    },
    [] as Array<{
      dataKey: string
      payload: { fill: string }
      value: number
    }>
  )

  return (
    <div
      className='shadow-tooltip bg-icon-default text-info-inverse relative z-50 space-y-4 rounded-[5px] p-4'
      data-testid={TOOLTIP_TEST_ID}
    >
      {!!total ? (
        <table>
          <tbody>
            {detailedPayload.map(({ dataKey, payload: { fill }, value }) => {
              if (!Number(value ?? 0)) {
                return null
              }
              return (
                <tr key={`tooltip-${dataKey}`}>
                  <td className='!text-info-inverse py-0.5 pl-0'>
                    <div className='flex items-center gap-2'>
                      <div className='h-4 w-4 rounded-sm' style={{ backgroundColor: fill }} />
                      {dataKey}
                    </div>
                  </td>
                  <td className='!text-info-inverse px-0 py-0.5'>{getValueInThousands(value)}</td>
                  <td className='!text-info-inverse py-0.5 pr-0'>{round((value / total) * 100, 2)}%</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      ) : (
        <div className='max-w-[200px]'>
          No data available yet. Send requests to see your daily request health for today.
        </div>
      )}
    </div>
  )
}
